import React, { useState } from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Bell, AlertCircle } from 'lucide-react';
import { useToast } from '@/components/ui/use-toast';

export function NotificationTest() {
  const [permission, setPermission] = useState(Notification.permission);
  const { toast } = useToast();

  const requestPermission = async () => {
    try {
      const result = await Notification.requestPermission();
      setPermission(result);
      
      if (result === 'granted') {
        toast({
          title: "Notifications activées",
          description: "Vous recevrez désormais des notifications du Baromètre Énergétique.",
        });
      } else {
        toast({
          variant: "destructive",
          title: "Notifications refusées",
          description: "Vous ne recevrez pas de notifications. Vous pouvez changer cela dans les paramètres de votre navigateur.",
        });
      }
    } catch (error) {
      console.error('Error requesting notification permission:', error);
      toast({
        variant: "destructive",
        title: "Erreur",
        description: "Impossible d'activer les notifications.",
      });
    }
  };

  const sendTestNotification = () => {
    if (permission !== 'granted') {
      toast({
        variant: "destructive",
        title: "Notifications non autorisées",
        description: "Veuillez d'abord autoriser les notifications.",
      });
      return;
    }

    // Envoyer une notification de test
    const notification = new Notification("Baromètre Énergétique HED", {
      body: "Ceci est une notification de test. Votre baromètre énergétique est prêt !",
      icon: "/icon-192x192.png",
      badge: "/icon-192x192.png",
      vibrate: [100, 50, 100],
      tag: 'test-notification',
      data: {
        dateOfArrival: Date.now(),
        primaryKey: 1
      }
    });

    notification.onclick = () => {
      window.focus();
      notification.close();
    };

    toast({
      title: "Notification envoyée",
      description: "Vérifiez la notification reçue.",
    });
  };

  return (
    <Card className="hover:shadow-lg transition-all">
      <CardContent className="p-6">
        <div className="flex flex-col items-center gap-4">
          <div className="p-3 bg-purple-100 rounded-full">
            <Bell className="w-6 h-6 text-purple-600" />
          </div>
          
          <div className="text-center">
            <h3 className="text-lg font-semibold mb-2">Test des Notifications</h3>
            <p className="text-sm text-gray-600 mb-4">
              Statut actuel : {' '}
              <span className={`font-medium ${
                permission === 'granted' ? 'text-green-600' :
                permission === 'denied' ? 'text-red-600' :
                'text-orange-600'
              }`}>
                {permission === 'granted' ? 'Activées' :
                 permission === 'denied' ? 'Refusées' :
                 'Non configurées'}
              </span>
            </p>
          </div>

          {permission === 'default' && (
            <Button 
              onClick={requestPermission}
              className="w-full bg-purple-600 hover:bg-purple-700"
            >
              Activer les notifications
            </Button>
          )}

          {permission === 'granted' && (
            <Button 
              onClick={sendTestNotification}
              className="w-full bg-purple-600 hover:bg-purple-700"
            >
              Envoyer une notification de test
            </Button>
          )}

          {permission === 'denied' && (
            <div className="text-center">
              <div className="flex items-center gap-2 text-red-600 mb-2">
                <AlertCircle className="w-4 h-4" />
                <span className="text-sm">Notifications bloquées</span>
              </div>
              <p className="text-sm text-gray-500">
                Veuillez autoriser les notifications dans les paramètres de votre navigateur pour recevoir des mises à jour.
              </p>
            </div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}